"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value.toString();
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/redux-actions@2.6.5/~/redux-actions/lib/utils/toString.js
// module id = 528
// module chunks = 0